import styled from "styled-components";

export const StyledCredits = styled.div`
    padding: 0.5rem 0.75rem;
    color: #FF844B;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    cursor: pointer;
    border-radius: 6px;
    gap: 4px;
    &:hover {
        background-color: rgba(255, 132, 75, 0.08);
    }
`